module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "permissionAdd"
  }, [_c('el-breadcrumb', {
    staticClass: "bread-nav",
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("权限管理")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("添加权限")])], 1), _vm._v(" "), _c('el-form', {
    ref: "addPermissionForm",
    staticClass: "addPermissionForm",
    attrs: {
      "model": _vm.addPermissionForm,
      "rules": _vm.validateRules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "权限名称",
      "prop": "permissionName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写权限名称"
    },
    model: {
      value: (_vm.addPermissionForm.permissionName),
      callback: function($$v) {
        _vm.addPermissionForm.permissionName = $$v
      },
      expression: "addPermissionForm.permissionName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "权限描述",
      "prop": "permissionContent"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请填写权限概述"
    },
    model: {
      value: (_vm.addPermissionForm.permissionContent),
      callback: function($$v) {
        _vm.addPermissionForm.permissionContent = $$v
      },
      expression: "addPermissionForm.permissionContent"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addPermission('addPermissionForm')
      }
    }
  }, [_vm._v("立即创建")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.clearPermissionData
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-3d9eb656"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/permissions/Add.vue
// module id = 757
// module chunks = 1